var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-preloader", { attrs: { show: _vm.loading } }),
      _vm._v(" "),
      _c("admin-breadcrumb", { attrs: { name: "Pricing Plans" } }),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "admin-panel",
                {
                  attrs: { title: "App Pricing Plans", "with-footer": "" },
                  scopedSlots: _vm._u([
                    {
                      key: "header-right",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            [
                              _c(
                                "no-permission-wrapper",
                                { attrs: { show: !_vm.canCreatePricingPlans } },
                                [
                                  _c(
                                    "b-btn",
                                    {
                                      attrs: {
                                        variant: "primary",
                                        to: { name: "admin-pricing-plan-add" },
                                        disabled: !_vm.canCreatePricingPlans,
                                      },
                                    },
                                    [_vm._v("New Pricing Plan")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("admin-pricing-plans-table", {
                    attrs: { plans: _vm.plans },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }